import React from 'react';
import { relistListNotice, relistUpdatedLabel } from '../utils/saleState';

/**
 * Sale-page dispute notice (Oct 2026). Rendered by SalePage only while auctions/{id}.disputeOpen
 * is true, with auctions/{id}.disputeNotice as the text. Same look as the home-page SiteNotice.
 * Presentational: no state, no storage. Email addresses in the text become mailto: links.
 */
const EMAIL = /([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})/g;

const linkify = (text: string) =>
  text.split(EMAIL).map((part, i) =>
    i % 2 === 1 ? (
      <a key={i} href={`mailto:${part}`} className="font-semibold text-amber-900 underline break-all">
        {part}
      </a>
    ) : (
      <React.Fragment key={i}>{part}</React.Fragment>
    ),
  );

/**
 * relistCount / relistUpdatedAt / relistUpdateNote: from auction.disputedLots / disputedLotsUpdatedAt /
 * disputedLotsUpdateNote (all written by set-disputed-lots.mjs). When the list is
 * absent or empty only the notice text shows. All wording comes from saleState.ts.
 */
const SaleDisputeNotice: React.FC<{ text: string; relistCount?: number; relistUpdatedAt?: unknown; relistUpdateNote?: unknown }> = ({
  text,
  relistCount = 0,
  relistUpdatedAt,
  relistUpdateNote,
}) => {
  const updated = relistUpdatedLabel(relistUpdatedAt, relistUpdateNote);
  return (
    <div
      role="status"
      className="w-full mb-6 bg-amber-50 border border-amber-300 rounded-lg px-4 py-4 sm:px-6 text-gray-900 text-sm sm:text-base leading-relaxed whitespace-pre-line"
    >
      {linkify(text)}
      {relistCount > 0 && (
        <p className="mt-3 text-xs sm:text-sm text-gray-800">
          {linkify(relistListNotice(relistCount))}
          {updated && <span className="block mt-1 text-gray-600">{updated}</span>}
        </p>
      )}
    </div>
  );
};

export default SaleDisputeNotice;
